import dateUtils from '@utils/dateUtils';
import normalizeGuest from './guest';

export default function normalize(stayRange = {}, roomCriteria = {}) {
    const ret = {
        startDateTime: stayRange.checkin ? dateUtils.parseDateString(stayRange.checkin) : null,
        endDateTime: stayRange.checkout ? dateUtils.parseDateString(stayRange.checkout) : null,
        guests: normalizeGuest(roomCriteria),
        roomsCount: roomCriteria.roomCount || 0,
    };
    ret.nights = dateUtils.differenceInCalendarDays(ret.endDateTime, ret.startDateTime);

    return ret;
}
